<template>
  <div class="description-preview-container px-1">
    <!-- Fade Overlay -->
    <div class="preview-fade-overlay" />
    <!-- Header -->
    <div class="relative w-full flex items-center gap-2 pt-3 pb-1 px-2" style="z-index: 50;">
      <AIGeneratedTextIcon class="text-icon-normal flex-shrink-0" />
      <BaseText type="label" size="sm" class="text-text-normal">
        {{ isCustom ? 'Custom Description' : 'AI Generated Description' }}
      </BaseText>
    </div>
    <!-- Content -->
    <div class="description-preview-content px-2 pt-2" v-html="htmlContent" />
  </div>
</template>

<script>
import AIGeneratedTextIcon from '../../globals/Icons/AIGeneratedTextIcon.vue'

export default {
  name: 'AIDescriptionPreview',
  components: {
    AIGeneratedTextIcon
  },
  props: {
    htmlContent: {
      type: String,
      required: true
    },
    isCustom: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.description-preview-container {
  position: relative;
  width: 100%;
  height: 220px;
  border-radius: 10px;
  box-shadow: 0 1px 2px 0 rgba(0, 56, 108, 0.08), 0 0 0 1px rgba(0, 56, 108, 0.08);
}
.preview-fade-overlay {
  position: absolute;
  top: 0;
  left: 12px;
  right: 9px;
  height: 44px;
  background: linear-gradient(to bottom, white 0px, white 36px, transparent 100%);
  z-index: 20;
}

.description-preview-content {
  overflow-y: auto;
  height: 184px;

  /* Text Styling */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  color: #060710;
}
.description-preview-content::-webkit-scrollbar {
  width: 5px;
}
.description-preview-content::-webkit-scrollbar-thumb {
  background-color: #DFE1E7;
  border-radius: 18px;
}
.description-preview-content ::v-deep ul,
.description-preview-content ::v-deep ol {
  list-style-position: inside;
  margin: 0.5rem 0;
}
.description-preview-content ::v-deep p {
  min-height: 20px;
  margin-bottom: 0.5rem;
}
.description-preview-content ::v-deep ol > li {
  list-style-type: decimal;
}
.description-preview-content ::v-deep li > p {
  display: inline;
  margin: 0;
}
.description-preview-content ::v-deep :is(h1, h2, h3, h4, h5, h6) {
  margin-bottom: 0.25rem;
}
.description-preview-content ::v-deep * + :is(h1, h2, h3, h4, h5, h6) {
  margin-top: 0.75rem;
}
</style>